// Wave 20.49cw — Minimal Mapbox attribution, in one place.
//
// Mapbox's terms require the wordmark plus the text attribution
// ("© Mapbox © OpenStreetMap Improve this map") on every map. The
// default AttributionControl collapses into an (i) button that opens
// a popover whenever the map is narrower than 640 px — the rider
// doesn't want that button or the modal. `compact: false` renders
// the text inline, always: no button, no popover, still compliant.
// Global styling in index.css keeps it small and low-contrast.
//
// Every `new mapboxgl.Map({...})` in the app passes
// `attributionControl: false` and then calls this.

import mapboxgl from 'mapbox-gl';
import '../mapAttribution.css';

export function attachMinimalAttribution(
  map: mapboxgl.Map,
  position: 'bottom-right' | 'bottom-left' = 'bottom-right',
): void {
  try {
    map.addControl(new mapboxgl.AttributionControl({ compact: false }), position);
  } catch {
    /* map already disposed — nothing to attribute */
  }
}
